var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgP(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 30C0 13.4315 13.4315 0 30 0V0C46.5685 0 60 13.4315 60 30V30C60 46.5685 46.5685 60 30 60V60C13.4315 60 0 46.5685 0 30V30Z",
    fill: "#E6A7BB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.5792 40V19.6364H30.4599C32.0574 19.6364 33.3633 19.9247 34.3775 20.5014C35.3983 21.0715 36.154 21.8438 36.6445 22.8182C37.1351 23.7926 37.3803 24.8797 37.3803 26.0795C37.3803 27.2794 37.1351 28.3698 36.6445 29.3509C36.1606 30.3319 35.4116 31.1141 34.3974 31.6974C33.3832 32.2741 32.0839 32.5625 30.4996 32.5625H25.5678V30.375H30.4201C31.5139 30.375 32.3922 30.1861 33.055 29.8082C33.7179 29.4304 34.1985 28.92 34.4968 28.277C34.8017 27.6274 34.9542 26.8949 34.9542 26.0795C34.9542 25.2642 34.8017 24.535 34.4968 23.892C34.1985 23.2491 33.7146 22.7453 33.0451 22.3807C32.3756 22.0095 31.4873 21.8239 30.3803 21.8239H26.0451V40H23.5792Z",
    fill: "#5D0E27"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgP);
export default __webpack_public_path__ + "static/media/p.bd9d4dce7de3989ddaf05a0bec4e2c86.svg";
export { ForwardRef as ReactComponent };